/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Tag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Tag"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#0E0E0E"
        d="M8.042 9.768a1.726 1.726 0 1 0 0-3.452 1.726 1.726 0 0 0 0 3.452"
      />
      <path
        fill="#0E0E0E"
        fillRule="evenodd"
        d="M20.989 14.799a3.45 3.45 0 0 0 0-4.883l-6.905-6.905A3.45 3.45 0 0 0 11.643 2h-6.19A3.453 3.453 0 0 0 2 5.453v6.19c0 .915.364 1.793 1.011 2.44l6.905 6.906a3.45 3.45 0 0 0 4.883 0zm-7.41 4.97a1.726 1.726 0 0 1-2.442 0l-6.905-6.906a1.73 1.73 0 0 1-.506-1.22v-6.19c0-.954.773-1.727 1.727-1.727h6.19c.457 0 .896.182 1.22.506l6.905 6.905a1.726 1.726 0 0 1 0 2.441z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export const TagIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'tag-icon'}
      icon={Tag}
      {...props}
      size={size}
    />
  );
};
